import React from "react";

const DetailImg = ()=>{
    return (

        <div className="detail_img">
            <img src={process.env.PUBLIC_URL + "/img/8149_PK_03.jpg"} alt='detail' />
        </div>
    )
}

export default DetailImg;